<script setup>
import { computed, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import Loading from '@/components/common/Loading.vue';
import { useStore } from 'vuex';
import { $api } from '@/services';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import CreateForm from './CreateFormModal.vue';
import DeleteForm from './DeleteForm.vue';
import LoadingDowloadPDF from '@/views/plansDetail/features/reportTarget/loadingDowloadPDF/loadingDowloadPDF.vue';

const store = useStore();
const route = useRoute();
const modalIsOpen = ref(false);
const searchQuery = ref('');
const id = ref(null);
const form = ref(null);
const typing = ref(null);
const listForm = ref([]);
const isLoading = ref(true);
const type = ref('');
const tabs = [
	{ name: 'Biểu mẫu tham khảo' },
	{ name: 'Biểu mẫu của trung tâm' },
];
const tabSelected = ref(0);
const requestSeq = ref(0);
const duplicatingId = ref(null);
const isReference = computed(() => tabSelected.value === 0);

const openMenuAction = (data) => {
	if (id.value == data) {
		id.value = null;
	} else {
		id.value = data;
	}
};

onMounted(() => {
	if (route.query.tab === 'center') tabSelected.value = 1;
	fetchData();
});

const openModal = (modalType, data) => {
	type.value = modalType;
	modalIsOpen.value = true;
	id.value = null;
	form.value = data;
};

const closeModal = () => {
	modalIsOpen.value = false;
	type.value = '';
	fetchData();
};

const searching = () => {
	clearTimeout(typing.value);
	typing.value = setTimeout(() => {
		fetchData();
	}, 300);
};

const selectTab = (index) => {
	if (tabSelected.value === index) return;
	tabSelected.value = index;
	id.value = null;
	listForm.value = [];
	isLoading.value = true;
	fetchData();
};

const librariesOf = (item) =>
	Array.isArray(item?.goal_library_names) ? item.goal_library_names : [];

const fetchData = async () => {
	const requestId = ++requestSeq.value;
	try {
		const res = await $api.form.list(searchQuery.value, isReference.value);
		if (requestId !== requestSeq.value) return;
		listForm.value = res?.data?.data || [];
	} catch (err) {
		if (requestId !== requestSeq.value) return;
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	} finally {
		if (requestId === requestSeq.value) isLoading.value = false;
	}
};

const deleteFormEvaluation = async () => {
	try {
		await $api.form.deleteForm(form.value.id);
		await store.dispatch('setAlertMessage', {
			message: 'Xoá biểu mẫu thành công',
			type: 'success',
		});
		closeModal();
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
const duplicateForm = async (formId) => {
	try {
		await $api.form.duplicateForm(formId);
		await store.dispatch('setAlertMessage', {
			message: 'Nhân bản biểu mẫu thành công',
			type: 'success',
		});
		fetchData();
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
const duplicateReference = async (formId) => {
	if (duplicatingId.value) return;
	duplicatingId.value = formId;
	id.value = null;
	try {
		const res = await $api.form.duplicateForm(formId, true);
		if (!res) return;
		await store.dispatch('setAlertMessage', {
			message: 'Tạo bản sao biểu mẫu thành công',
			type: 'success',
		});
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	} finally {
		duplicatingId.value = null;
	}
};
async function downloadPDF(val, reference = false) {
	const referenceQuery = reference ? '&is_reference=true' : '';
	const url =
		process.env.VUE_APP_PDF_URL +
		'form-evaluation/' +
		val +
		'?token=' +
		localStorage.getItem('tk') +
		'&subdomain=' +
		localStorage.getItem('sub-domain') +
		referenceQuery;
	const params = {
		url: url,
		format: 'a2',
		id_render: 'form_pdf',
	};
	try {
		id.value = null;
		type.value = 'loading';
		modalIsOpen.value = true;
		const response = await fetch(
			'https://g4ridpplxi.execute-api.ap-southeast-1.amazonaws.com/',
			{
				method: 'POST',
				body: JSON.stringify(params),
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			}
		);
		if (!response.ok) {
			window.location.href = url + '&is_print=true';
			closeModal();
			return;
		}
		const data = await response.json();
		if (data.data) {
			closeModal();
			const linkSource = `data:application/pdf;base64, ${data.data}`;
			const link = document.createElement('a');
			const fileName = 'BieuMauDanhGia.pdf';
			link.href = linkSource;
			link.download = fileName;
			link.click();
		}
	} catch (e) {
		window.location.href = url + '&is_print=true';
		closeModal();
		console.log(e);
	}
}
</script>
<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<create-form
			v-if="type === 'create' || type === 'edit'"
			@close="closeModal"
			:type="type"
			:form="form ? form : null"
			:open="modalIsOpen"
		/>
		<delete-form
			v-if="type === 'delete'"
			@submit="deleteFormEvaluation"
			@close="closeModal"
		/>
		<LoadingDowloadPDF
			v-if="type === 'loading'"
			:text="'Đang tải xuống file PDF Biểu mẫu đánh giá...'"
		/>
	</DaModalFrame>
	<div class="px-12 md-down:px-4 pb-30">
		<div
			class="__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl gap-4"
			>
				<img src="@/assets/images/icons/form-evaluation.png" alt="" />
				<div>Biểu mẫu đánh giá</div>
			</div>
			<div class="items-center flex gap-3">
				<div
					class="search-input max-w-lg w-full"
					style="min-width: 320px"
				>
					<div class="input-group">
						<input
							v-model="searchQuery"
							class="bg-white input-with-icon form-search-input"
							placeholder="Tìm theo tên mẫu"
							type="text"
							@keyup="searching"
						/>
						<div class="input-icon absolute top-1/2">
							<DaIcon
								class="h-4 w-4 text-neutral-400"
								name="das--search"
							/>
						</div>
					</div>
				</div>
				<button
					class="button-p btn--ghost w-fit px-4 form-create-btn"
					type="button"
					@click="openModal('create')"
				>
					Tạo mới
				</button>
			</div>
		</div>
		<div class="border-b border-neutral-200">
			<nav class="-mb-px flex gap-8">
				<div
					v-for="(tab, index) in tabs"
					:key="tab.name"
					class="whitespace-nowrap pb-4 px-1 border-b-2 text-base cursor-pointer"
					:class="
						tabSelected === index
							? 'border-yellow-500 text-yellow-700 font-semibold'
							: 'border-transparent text-neutral-500 hover:text-yellow-700'
					"
					@click="selectTab(index)"
				>
					{{ tab.name }}
				</div>
			</nav>
		</div>
		<div v-if="isLoading" class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
		<div v-else-if="isReference">
			<div v-if="listForm.length > 0" class="mt-10">
				<div class="shadow-sm rounded-lg">
					<table class="min-w-full">
						<thead class="bg-neutral-100">
							<tr>
								<th
									scope="col"
									class="w-16 px-4 py-6 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
								>
									STT
								</th>
								<th
									scope="col"
									class="px-4 py-6 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
								>
									Biểu mẫu
								</th>
								<th
									scope="col"
									class="px-4 py-6 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
								>
									Thư viện sử dụng
								</th>
								<th scope="col" class="w-16 px-4 py-6"></th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(form, index) in listForm"
								:key="form.id"
								class="cursor-pointer hover:bg-orange-50"
								:class="
									index % 2 === 0
										? 'bg-white'
										: 'bg-neutral-50'
								"
								@click="
									$router.push(
										`/form-evaluation/${form.id}?is_reference=true`
									)
								"
							>
								<td
									class="px-4 py-4 align-middle whitespace-nowrap text-neutral-700"
								>
									{{ index + 1 }}
								</td>
								<td class="px-4 py-4 align-middle">
									<div
										class="text-base leading-6 text-neutral-700"
									>
										{{ form.name }}
									</div>
									<div class="form-meta mt-2">
										{{ form.skill_count || 0 }} Lĩnh vực |
										{{ form.goal_count || 0 }} mục tiêu
									</div>
								</td>
								<td
									class="px-4 py-4 align-middle text-base leading-6 text-neutral-700"
								>
									<div
										v-for="(
											library, libraryIndex
										) in librariesOf(form)"
										:key="libraryIndex"
									>
										{{ library }}
									</div>
								</td>
								<td class="px-4 py-4 align-middle" @click.stop>
									<div
										class="w-full flex justify-center items-center relative"
									>
										<img
											class="w-6 h-6 cursor-pointer"
											src="@/assets/images/icons/three-dots.png"
											alt=""
											@click.stop="
												openMenuAction(form.id)
											"
										/>
										<div
											v-if="form.id == id"
											class="absolute menu-action py-1 z-10"
										>
											<div
												class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
												@click.stop="
													duplicateReference(form.id)
												"
											>
												<img
													class="w-4 h-4"
													src="@/assets/images/icons/copy.png"
													alt=""
												/>
												<div class="text-neutral-700">
													Tạo bản sao
												</div>
											</div>
											<div
												class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50 cursor-pointer"
												@click.stop="
													downloadPDF(form.id, true)
												"
											>
												<img
													class="w-4 h-4"
													src="@/assets/images/icons/cloud-download-fill.png"
													alt=""
												/>
												<div class="text-neutral-700">
													Tải file pdf
												</div>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div
				v-else
				class="w-full h-full mt-20 flex items-center justify-center flex-col"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div
					class="text-neutral-500 text-lg text-center"
					style="max-width: 700px"
				>
					Chưa có biểu mẫu tham khảo.
				</div>
			</div>
		</div>
		<div v-else>
			<div v-if="listForm.length > 0">
				<div class="mt-10">
					<div class="flex flex-col">
						<div class="-my-2 sm:-mx-6 lg:-mx-8">
							<div
								class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
							>
								<div class="shadow sm:rounded-lg">
									<table
										class="min-w-full divide-y text-neutral-200"
									>
										<thead class="bg-neutral-100 h-16">
											<tr>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													STT
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													biểu mẫu
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													Thư viện nội bộ sử dụng
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													Lĩnh vực
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													mục tiêu
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													NGƯỜI TẠO
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													chỉnh sửa cuối
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-16"
												></th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(
													form, index
												) in listForm"
												:key="form.id"
												:class="
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												"
												class="hover:bg-orange-50 cursor-pointer"
												@click="
													$router.push(
														`/form-evaluation/${form?.id}`
													)
												"
											>
												<td
													class="px-6 py-4 whitespace-nowrap text-neutral-700"
												>
													{{ index + 1 }}
												</td>
												<td
													class="px-6 py-4 whitespace-pre-line text-neutral-700"
													style="min-width: 300px"
												>
													<div
														class="flex items-center gap-2"
													>
														<img
															class="w-5 h-5"
															src="@/assets/images/icons/form-evaluation.png"
															alt=""
														/>
														<div>
															{{ form.name }}
														</div>
													</div>
												</td>
												<td
													class="px-6 py-4 text-neutral-700"
												>
													<div
														class="flex flex-col gap-"
													>
														<div
															v-for="(
																l, lIndex
															) in form.goal_library_names"
															:key="lIndex"
														>
															- {{ l }}
														</div>
													</div>
												</td>
												<td
													class="px-6 py-4 whitespace-nowrap text-neutral-700"
												>
													{{ form.skill_count }}
												</td>
												<td
													class="px-6 py-4 whitespace-nowrap text-neutral-700"
												>
													{{ form.goal_count }}
												</td>
												<td
													class="px-6 py-4 text-neutral-700"
												>
													<div>
														<div
															v-if="
																form.created_by_staff
															"
															class="flex items-center mb-4"
														>
															<div>
																<img
																	v-if="
																		form
																			.created_by_staff
																			?.profile_photo
																			?.w200
																	"
																	:src="
																		form
																			.created_by_staff
																			?.profile_photo
																			?.w200
																	"
																	alt=""
																	class="shadow-sm inline-block h-9 w-9 rounded-full"
																/>
																<span
																	v-else
																	:style="{
																		background:
																			form
																				.created_by_staff
																				?.profile_photo
																				?.default
																				?.color,
																	}"
																	class="inline-flex items-center justify-center h-9 w-9 rounded-full"
																>
																	<span
																		class="font-medium leading-none text-white text-xs"
																		>{{
																			form
																				.created_by_staff
																				?.profile_photo
																				?.default
																				?.initial
																		}}</span
																	>
																</span>
															</div>
															<div
																class="ml-4 text-blue-600 font-semibold truncate"
															>
																{{
																	form
																		.created_by_staff
																		.name
																}}
															</div>
														</div>
														<div
															v-if="
																form.inserted_at
															"
														>
															{{
																$filters.formatDateTime(
																	form.inserted_at
																)
															}}
														</div>
													</div>
												</td>
												<td
													class="px-6 py-4 text-neutral-700"
												>
													<div>
														<div
															v-if="
																form.updated_by_staff
															"
															class="flex items-center mb-4"
														>
															<div>
																<img
																	v-if="
																		form
																			.updated_by_staff
																			?.profile_photo
																			?.w200
																	"
																	:src="
																		form
																			.updated_by_staff
																			?.profile_photo
																			?.w200
																	"
																	alt=""
																	class="shadow-sm inline-block h-9 w-9 rounded-full"
																/>
																<span
																	v-else
																	:style="{
																		background:
																			form
																				.updated_by_staff
																				?.profile_photo
																				?.default
																				?.color,
																	}"
																	class="inline-flex items-center justify-center h-9 w-9 rounded-full"
																>
																	<span
																		class="font-medium leading-none text-white text-xs"
																		>{{
																			form
																				.updated_by_staff
																				?.profile_photo
																				?.default
																				?.initial
																		}}</span
																	>
																</span>
															</div>
															<div
																class="ml-4 text-blue-600 font-semibold truncate"
															>
																{{
																	form
																		.updated_by_staff
																		.name
																}}
															</div>
														</div>
														<div
															v-if="
																form.updated_at
															"
														>
															{{
																$filters.formatDateTime(
																	form.updated_at
																)
															}}
														</div>
													</div>
												</td>

												<td>
													<div
														class="w-full flex justify-center items-center relative"
													>
														<img
															@click.stop="
																openMenuAction(
																	form.id
																)
															"
															class="w-6 h-6 cursor-pointer"
															src="@/assets/images/icons/three-dots.png"
															alt=""
														/>
														<div
															v-if="form.id == id"
															class="absolute menu-action py-1 z-10"
														>
															<div
																@click.stop="
																	$router.push(
																		`/form-evaluation/create/${form?.id}`
																	)
																"
																class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50"
															>
																<img
																	class="w-4 h-4"
																	src="@/assets/images/icons/pen.png"
																	alt=""
																/>
																<div
																	class="text-neutral-700"
																>
																	Chỉnh sửa
																</div>
															</div>
															<div
																@click.stop="
																	duplicateForm(
																		form.id
																	)
																"
																class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50"
															>
																<img
																	class="w-4 h-4"
																	src="@/assets/images/icons/copy.png"
																	alt=""
																/>
																<div
																	class="text-neutral-700"
																>
																	Nhân bản
																</div>
															</div>
															<div
																@click.stop="
																	openModal(
																		'edit',
																		form
																	)
																"
																class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50"
															>
																<img
																	class="w-4 h-4"
																	src="@/assets/images/icons/pen.png"
																	alt=""
																/>
																<div
																	class="text-neutral-700"
																>
																	Đổi tên
																</div>
															</div>
															<div
																@click.stop="
																	downloadPDF(
																		form.id
																	)
																"
																class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50"
															>
																<img
																	class="w-4 h-4"
																	src="@/assets/images/icons/cloud-download-fill.png"
																	alt=""
																/>
																<div
																	class="text-neutral-700"
																>
																	Tải file pdf
																</div>
															</div>
															<div
																@click.stop="
																	openModal(
																		'delete',
																		form
																	)
																"
																class="flex items-center gap-3 px-4 py-2 hover:bg-orange-50"
															>
																<img
																	class="w-4 h-4"
																	src="@/assets/images/icons/trash.png"
																	alt=""
																/>
																<div
																	class="text-neutral-700"
																>
																	Xoá
																</div>
															</div>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				v-else
				class="w-full h-full mt-20 flex items-center justify-center flex-col"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div
					class="text-neutral-500 text-lg text-center"
					style="max-width: 700px"
				>
					Trung tâm chưa có biểu mẫu nào.
				</div>
				<button
					type="button"
					class="h-12 button-p btn--ghost text-center px-6 whitespace-nowrap mt-4 w-max"
					@click="openModal('create')"
				>
					Tạo mới
				</button>
			</div>
		</div>
	</div>
</template>
<style scoped>
.form-search-input {
	height: 44px;
}
.form-create-btn {
	height: 44px;
}
.form-meta {
	font-size: 10px;
	line-height: 12px;
	letter-spacing: 0.8px;
	font-weight: 600;
	text-transform: uppercase;
	color: #94a3b8;
}
.menu-action {
	z-index: 100;
	bottom: -25px;
	right: 80px;
	border-radius: 6px;
	border: 1px solid #f9e3b7;
	background: #fff;
	width: 224px;
	box-shadow: 0px 10px 16px 0px rgba(20, 37, 63, 0.06),
		0px 0px 1px 0px rgba(12, 26, 75, 0.1);
}
</style>
